import { DefaultAPIInstance } from "@/api";

const message_url = 'messages/';

export const MessageAPI = {
    getMessages() {
        return DefaultAPIInstance.get(message_url)
    },
    deleteMessage(messageId) {
        return DefaultAPIInstance.delete(`${message_url}${messageId}/`)
    },
    changeStatusMessage(messageId, statusData) {
        return DefaultAPIInstance.patch(`${message_url}${messageId}/status/`, statusData)
    },
}
